import { apiClient } from "./apiClient";

const unwrapResponse = (data) => {
    if (Array.isArray(data)) {
        return data;
    }
    if (Array.isArray(data?.data)) {
        return data.data;
    }
    if (Array.isArray(data?.items)) {
        return data.items;
    }
    if (Array.isArray(data?.results)) {
        return data.results;
    }
    return [];
};

export const getMedicos = async () => {
    const data = await apiClient.get("/medicos");
    return unwrapResponse(data);
};

export const crearMedico = async (medico) => {
    return apiClient.post("/medicos", medico);
};

export const getPacientes = async () => {
    const data = await apiClient.get("/pacientes");
    return unwrapResponse(data);
};

export const getTurnos = async () => {
    const data = await apiClient.get("/turnos/buscar?limit=500");
    return unwrapResponse(data);
};

export const getTurnosDisponibles = async () => {
    const data = await apiClient.get("/turnos/disponibles");
    return unwrapResponse(data);
};

export const getTurnosPorPaciente = async (pacienteId) => {
    const data = await apiClient.get(`/turnos/buscar?paciente=${pacienteId}&limit=500`);
    return unwrapResponse(data);
};

export const getSedes = async () => {
    const data = await apiClient.get("/sedes");
    return unwrapResponse(data);
};

export const crearSede = async (sede) => {
    return apiClient.post("/sedes", sede);
};

export const agregarSedeAMedico = async (medicoId, sedeId) => {
    return apiClient.post(`/medicos/${medicoId}/sedes`, { sedeId });
};

export const agregarServicioAMedico = async (medicoId, servicioId) => {
    return apiClient.post(`/medicos/${medicoId}/servicios`, { servicioId });
};

export const getUsuarios = async () => {
    const data = await apiClient.get("/usuarios");
    return unwrapResponse(data);
};

export const getObrasSociales = async () => {
    const data = await apiClient.get("/obras-sociales");
    return unwrapResponse(data);
};

export const crearObraSocial = async (datos) => {
    const data = await apiClient.post("/obras-sociales", datos);
    return data?.data ?? data;
};

export const agregarPlanAObraSocial = async (obraSocialId, planId) => {
    const data = await apiClient.post(`/obras-sociales/${obraSocialId}/planes`, { planId });
    return data?.data ?? data;
};

export const getPlanes = async () => {
    const data = await apiClient.get("/planes");
    return unwrapResponse(data);
};

export const crearPlan = async (datos) => {
    const data = await apiClient.post("/planes", datos);
    return data?.data ?? data;
};

export const agregarCobertura = async (planId, cobertura) => {
    const data = await apiClient.post(`/planes/${planId}/coberturas`, cobertura);
    return data?.data ?? data;
};

export const modificarCobertura = async (planId, servicioId, cobertura) => {
    const data = await apiClient.put(`/planes/${planId}/coberturas/${servicioId}`, cobertura);
    return data?.data ?? data;
};

export const asignarPlanAPaciente = async (pacienteId, planId) => {
    const data = await apiClient.post(`/pacientes/${pacienteId}/plan`, { planId });
    return data?.data ?? data;
};

export const quitarPlanDePaciente = async (pacienteId) => {
    const data = await apiClient.delete(`/pacientes/${pacienteId}/plan`);
    return data?.data ?? data;
};

export const getServicios = async () => {
    const data = await apiClient.get("/servicios");
    return unwrapResponse(data);
};

export const createServicio = async (servicio) => {
    return apiClient.post("/servicios", servicio);
};

export const updateServicio = async (servicioId, servicio) => {
    return apiClient.patch(`/servicios/${servicioId}`, servicio);
};

export const generarTurnos = async () => {
    const data = await apiClient.post("/turnos/generador");
    return data;
};

export const reservarTurno = async (turnoId, pacienteId) => {
    return apiClient.patch(`/turnos/${turnoId}`, {
        id_paciente: pacienteId,
        estado: "RESERVADO",
    });
};

export const actualizarTurno = async (turnoId, cambios) => {
    return apiClient.patch(`/turnos/${turnoId}`, cambios);
};

export const getDisponibilidades = async (medicoId) => {
    const data = await apiClient.get(`/medicos/${medicoId}/disponibilidades`);
    return unwrapResponse(data);
};

export const crearDisponibilidad = async (medicoId, disponibilidad) => {
    const data = await apiClient.post(`/medicos/${medicoId}/disponibilidades`, disponibilidad);
    return unwrapResponse(data);
};

export const actualizarDisponibilidad = async (medicoId, disponibilidadId, disponibilidad) => {
    const data = await apiClient.patch(`/medicos/${medicoId}/disponibilidades/${disponibilidadId}`, disponibilidad);
    return unwrapResponse(data);
};

export const eliminarDisponibilidad = async (medicoId, disponibilidadId, disponibilidad) => {
    const data = await apiClient.delete(`/medicos/${medicoId}/disponibilidades/${disponibilidadId}`, {
        data: disponibilidad,
    });
    return unwrapResponse(data);
};

export const crearUsuario = async (usuario) => {
    return apiClient.post("/usuarios", usuario);
};

export const asignarUsuarioAMedico = async (medicoId, usuarioId) => {
    return apiClient.patch(`/medicos/${medicoId}/usuario`, { usuarioId });
};

export const getNotificacionesNoLeidas = async (usuarioId) => {
    const data = await apiClient.get(`/notificaciones/usuarios/${usuarioId}/no-leidas`);
    return unwrapResponse(data);
};

export const getNotificacionesLeidas = async (usuarioId) => {
    const data = await apiClient.get(`/notificaciones/usuarios/${usuarioId}/leidas`);
    return unwrapResponse(data);
};

export const marcarNotificacionLeida = async (notificacionId) => {
    return apiClient.patch(`/notificaciones/${notificacionId}`, { leida: true });
};

export const proponerCambioFecha = async (turnoId, fechaHora, medicoId, pacienteId) => {
    return apiClient.patch(`/turnos/${turnoId}`, {
        tipoModificacionEnum: "PROPONER_CAMBIO_FECHA",
        fechaHora,
        id_medico: medicoId ?? undefined,
        id_paciente: pacienteId ?? undefined,
    });
};

export const aceptarCambioFecha = async (turnoId, medicoId, pacienteId) => {
    return apiClient.patch(`/turnos/${turnoId}`, {
        tipoModificacionEnum: "ACEPTAR_CAMBIO_FECHA",
        id_medico: medicoId ?? undefined,
        id_paciente: pacienteId ?? undefined,
    });
};

export const rechazarCambioFecha = async (turnoId, medicoId, pacienteId) => {
    return apiClient.patch(`/turnos/${turnoId}`, {
        tipoModificacionEnum: "RECHAZAR_CAMBIO_FECHA",
        id_medico: medicoId ?? undefined,
        id_paciente: pacienteId ?? undefined,
    });
};